module.exports = __webpack_public_path__ + "img/megaphone.2847418a.svg";